import { getLocale } from "../runtime";

const sv_hrcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kroatien`
};

const hrcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_hrcountry(inputs)
	return "hrCountry";
};

export { hrcountry as "hrCountry" };